export default "__VITE_ASSET__2e9cc07b__"